<template>
  <div class="baseDialog" :class="{ 'inline-form': inlineForm, 'cant-close': cantClose }">
    <!-- 封装弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :width="popupWidth" :before-close="handleClose">
      <div :class="center ? 'dialog-center' : ''">
        <slot></slot>
      </div>
      <div v-if="!noFooter" class="dialog-footer" :style="{ marginLeft: footCenter ? 'auto' : '156px' }">
        <el-button @click="handleClose">{{ $t('execall.cancel') }}</el-button>
        <el-button type="primary" @click="Save" v-log="{ page_event: 'c_save' }" :disabled="isSaveDisabled">{{ $t('account.save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'baseDialog',
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    popupWidth: {
      type: String,
      default: '520px'
    },
    center: Boolean,
    noFooter: Boolean,
    isViewDialog: {
      type: Boolean,
      default: false
    },
    inlineForm: {
      type: Boolean,
      default: false
    },
    footCenter: {
      type: Boolean,
      default: false
    },
    cantClose: {
      type: Boolean,
      default: false
    },
    isSaveDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      }
    }
  },
  methods: {
    Cancel() {
      this.$emit('resetPopupData')
    },
    Save() {
      this.$emit('submitPopupData')
    },
    handleClose() {
      if (this.isViewDialog) {
        this.$emit('handleClose')
      } else {
        this.$confirm(this.$t('tips.close_strategy'), this.$t('workFlow.tips'), {
          center: true
        })
          .then(() => {
            this.$emit('handleClose')
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.baseDialog {
  width: 560px;

  .el-dialog {
    z-index: 9;
    background-color: #fff;
    border-radius: 8px;
  }

  .el-dialog__body {
    padding: 16px 20px 40px;
    box-sizing: border-box;
    word-break: break-word;

    .el-form .el-form-item {
      margin-bottom: 12px;
    }
  }

  .dialog-footer {
    padding-top: 28px;
    display: flex;
    justify-content: center;
    width: 320px;
    margin-left: 156px;

    .el-button {
      width: 154px;
      & + .el-button {
        margin-left: 12px;
      }
    }
  }
}
.dialog-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.inline-form {
  .dialog-footer {
    margin-left: 0;
    width: 100%;
  }

  .el-form {
    .el-form-item {
      margin-bottom: 12px;
      display: flex;
      flex-flow: column;
      .el-form-item__label {
        text-align: left;
        font-size: 12px;
        line-height: 20px;
        color: $base-text-primary;
        margin-bottom: 4px;
      }

      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/baseDialog.vue